<template>
  <v-skeleton-loader
    class="mensagem-optout-suffix mb-6"
    height="178"
    type="image"
    transition="fade-transition"
    :loading="$apollo.queries.optout_suffix_message.loading"
  >
    <v-card class="mb-6" height="178">
      <v-card-title class="pb-3">
        <span class="table-card-title px-0">Mensagem de descadastro</span>

        <v-tooltip right max-width="300px">
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <mf-icon small class="ml-3 mb-1" color="cinza-0">info</mf-icon>
            </span>
          </template>
          <span>Por padrão, ao final de toda mensagem será enviada para seus clientes a opção de descadastramento.</span>
        </v-tooltip>
        <v-spacer />
        <optout-message-variations :messages="optout_suffix_messages" />
      </v-card-title>
      <v-card-text>
        <v-text-field v-model="optout_suffix_message" class="texto-corrido" label="Mensagem principal" :disabled="!editing" outlined counter="70" />
      </v-card-text>
    </v-card>
  </v-skeleton-loader>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import gql from 'graphql-tag'

const QUERY_GET_MESSAGE_BY_TYPE = gql`
  query GetMessageByType {
    getMessageByType(type: OPTOUT_SUFFIX) {
      _id
      type
      interpolated_text
      interpolated_texts
    }
  }
`

export default {
  components: {
    OptoutMessageVariations: () => import('@/modules/campanhas/whatsapp/views/components/OptoutMessagesVariations.vue'),
  },
  data: () => ({
    optout_suffix_message: '',
    optout_suffix_messages: [],
    backup_optout_suffix_message: '',
    editing: false,
  }),
  apollo: {
    optout_suffix_message: {
      query: QUERY_GET_MESSAGE_BY_TYPE,
      update({ getMessageByType }) {
        this.optout_suffix_messages = getMessageByType.interpolated_texts
        return getMessageByType.interpolated_text
      },
    },
  },
  methods: {
    startEdit() {
      this.backup_optout_suffix_message = cloneDeep(this.optout_suffix_message)
      this.editing = true
    },
    endEdit() {
      this.editing = false
    },
    cancel() {
      this.optout_suffix_message = this.backup_optout_suffix_message
      this.endEdit()
    },
  },
}
</script>
